import get from 'lodash/get';

import { rolesEnum } from '../../users/constants';
import storedUserInfo from '../../utils/session-data/user-info';

const isUI = variant =>
  get(storedUserInfo.get(), 'uiVariant', 'PC') === variant;

const isSuperuser = () =>
  get(storedUserInfo.get(), 'roles')?.includes(rolesEnum.SUPERUSER);

const hasSBORole = () => {
  const SBORoles = [
    rolesEnum.SALES_BACK_OFFICE_LEAD,
    rolesEnum.SALES_BACK_OFFICE_TEAM,
  ];
  const userRoles = get(storedUserInfo.get(), 'roles');
  return userRoles ? SBORoles.some(role => userRoles.includes(role)) : false;
};

/* eslint-disable react/prop-types */
function PC({ children }) {
  return isUI('PC') ? children : null;
}

function AdOps({ children }) {
  return isUI('AdOps') ? children : null;
}

function Accounting({ children }) {
  return isUI('Accounting') ? children : null;
}

function Lead({ children }) {
  return isUI('Lead') ? children : null;
}

function SalesBackoffice({ children }) {
  return isUI('SalesBackoffice') ? children : null;
}

function Collabary({ children }) {
  return isUI('Collabary') ? children : null;
}

const isAdOps = () => isUI('AdOps');

const isPC = () => isUI('PC');

const isAccounting = () => isUI('Accounting');

const isLead = () => isUI('Lead');

const isSBO = () => isUI('SalesBackoffice');

const isCollabary = () => isUI('Collabary');

export {
  Accounting,
  AdOps,
  Collabary,
  hasSBORole,
  isAccounting,
  isAdOps,
  isCollabary,
  isLead,
  isPC,
  isSBO,
  isSuperuser,
  Lead,
  PC,
  SalesBackoffice,
};
